<template>
  <div>
    <template v-if="payouts !== null">
      <div class="card">
        <div class="card-header chart-title">Acties over tijd</div>
        <div class="card-graph">
          <GChart
            :settings="{ packages: ['corechart'], language: 'nl-nl' }"
            :data="data"
            :options="options"
            :events="chartEvents"
            type="ComboChart"
          />
        </div>
        <div id="payouts-tooltip"></div>
      </div>
      <div class="row menubar">
        <input
          type=text ref="search" placeholder="Zoeken" @keyup="updateSearch"
          class="searchbar" style="width: 100px"
        >
        <inputDropdown
          :array="firstAction"
          v-model="hasAction"
          style="float:right"
          displayPrefix="Aan de beurt: "
        />
        <inputDropdown
          :array="filters"
          v-model="hasIntake"
          style="float:right"
          displayPrefix="Intake: "
        />
        <inputDropdown
          :array="filters"
          v-model="hasOffer"
          style="float:right"
          displayPrefix="Offerte: "
        />
        <inputDropdown
          :array="filters"
          v-model="hasPayout"
          style="float:right"
          displayPrefix="Uitbetaling: "
        />
        <button style="float: right;" @click="download">
          Download ({{payouts.length}})
        </button>
      </div>
      <div class="card">
        <table width=100%>
          <thead class="table-legend">
            <tr>
              <th>#</th>
              <th>Intake Datum</th>
              <th>Start / looptijd </th>
              <th>Type/inleg</th>
              <th>U/R-rend</th>
              <th>Eerste uit/start</th>
              <th>Aan de beurt</th>
              <th>Interval</th>
              <th>Nbr/lhk/ulhk</th>
              <th>Laatste uitkeer</th>
              <th colspan="3">Revisie</th>
            </tr>
          </thead>
          <tr
            v-for="(payout, index) in slice(
              filter(payouts, searchFilter),
              currentPage * resultsPerPage,
              (currentPage + 1) * resultsPerPage)"
            :key="index"
          >
            <td width="50">{{payout.id}}</td>
            <td>
              {{(new Date(payout.intake_date)).toLocaleDateString()}}
              <br />
              <a style="cursor: pointer" @click="redoIntake(payout.id)">
                <span class="grey">
                  {{ payout.complete_date !== null ? 'Open' : 'Vervolg' }}
                </span>
              </a>
            </td>
            <td v-if="payout.revision === null">
              ?
            </td>
            <td v-else>
              {{(new Date(payout.start_date)).getMonth() + 1}}
              {{(new Date(payout.start_date)).getFullYear()}}
              <br />
              <span class="grey">{{ payout.offer ? `${payout.offer.looptijd} jaar` : '?' }}</span>
            </td>
            <td colspan="6" v-if="!payout.offer">Geen offerte</td>
            <template v-else>
              <td>
                {{ toOfferType(Number(payout.offer.offerType)) }}
                <br />
                <span class="grey">&euro;{{ formatPrice(payout.offer.vermogen, true) }},-</span>
              </td>
              <td>
                {{ formatPrice(payout.offerAdmin.urendement) }}%
                <br />
                <span class="grey">{{ formatPrice(payout.offerAdmin.profile) }}%</span>
              </td>
              <td>
                &euro;{{ toFirstYear(payout) }},-
                <br />
                <span class="grey">&euro;{{ payout.intakeData.rekeningData.paymentStart }},-</span>
              </td>
              <td>{{ textFirstAction(payout.firstAction) }}</td>
              <td>{{ payout.offer.stortingenInterval }}</td>
              <td>
                <awesomeIcon
                  v-if="payout.type !== 10"
                  style="margin-right: 5px"
                  :icon="payout.offer.nextOfKin ? 'check' : 'times'"
                />
                <awesomeIcon
                  v-if="payout.type !== 12"
                  style="margin-right: 5px"
                  :icon="
                    payout.intakeData.rekeningData.loonheffingskorting
                      ? payout.intakeData.rekeningData.loonheffingskorting === 'Yes'
                        ? 'check'
                        : 'times'
                      : 'question'
                  "
                />
                <awesomeIcon
                  v-if="payout.type !== 12"
                  :icon="
                    payout.intakeData.rekeningData.uitzonderingloonheffing
                      ? payout.intakeData.rekeningData.uitzonderingloonheffing  === 'Yes'
                        ? 'check'
                        : 'times'
                      : 'question'
                  "
                />
              </td>
            </template>
            <td v-if="payout.revision === null" colspan="3">Geen uitbetaling</td>
            <template v-else>
              <td>
                {{(new Date(payout.lastpayout_date)).getMonth() + 1}}
                {{(new Date(payout.lastpayout_date)).getFullYear()}}
              </td>
              <td>{{ payout.revision }}</td>
              <td @click="openPayout(payout.id)">
                <awesomeIcon icon="search" style="cursor: pointer" />
              </td>
            </template>
          </tr>
        </table>
        <pagerElement
          v-model="currentPage"
          :records="filter(payouts, searchFilter).length"
          :resultsPerPage="resultsPerPage"
        />
      </div>
    </template>
    <div v-else class="loader" />
  </div>
</template>

<script>
import {
  slice, filter, find, map, sum,
} from 'lodash-es';
import FileSaver from 'file-saver';

export default {
  name: 'AdminPayouts2',
  data() {
    return {
      search: '',
      dropdownlistIntake: false,
      dropdownlistOffer: false,
      dropdownlistPayout: false,
      payouts: null,
      currentPage: 0,
      resultsPerPage: 10,
      hasPayout: null,
      hasOffer: null,
      hasIntake: null,
      hasAction: null,
      filters: [
        {
          label: 'Ja / Nee',
          value: null,
        },
        {
          label: 'Ja',
          value: true,
        },
        {
          label: 'Nee',
          value: false,
        },
      ],
      firstAction: [
        {
          label: 'Alle',
          value: null,
        },
        {
          label: 'Deze maand',
          value: 0,
        },
        {
          label: 'Volgende maand',
          value: 1,
        },
        {
          label: 'Over 2 maanden',
          value: 2,
        },
        {
          label: 'Over 3 maanden',
          value: 3,
        },
        {
          label: 'Zonder actie',
          value: -1,
        },
      ],
      chartType: 'BarChart',
      options: {
        height: 300,
        colors: JSON.parse(JSON.stringify(process.env.VUE_APP_STYLE === 'db' ? ['#6c0', '#006'] : this.$store.state.colorScheme)),
        legend: {
          position: 'none',
        },
        chartArea: {
          left: 65,
          top: 25,
          bottom: 30,
          right: 20,
          width: '100%',
          height: '100%',
        },
        tooltip: {
          trigger: 'none',
        },
      },
      columns: [
        {
          type: 'string',
          label: 'Due month',
        },
        {
          type: 'number',
          label: 'Maanden',
        },
      ],
      chartEvents: {
        onmouseover: this.setTooltipContent,
        onmouseout: () => { this.setTooltipContent(null); },
      },
    };
  },
  created() {
    this.getProfiles();
  },
  computed: {
    data() {
      return [this.columns].concat(this.rows);
    },
    rows() {
      const temp = [];
      const date = new Date();
      for (let i = 0; i <= 24; i += 1) {
        temp.push([`${i}`, filter(this.payouts, (o) => {
          if (o.start_date) {
            const startDate = new Date(o.start_date);
            if (
              startDate.getMonth() === date.getMonth()
              && startDate.getFullYear() === date.getFullYear()
            ) {
              return true;
            }
            if (
              date.getFullYear() < (startDate.getFullYear() + Number(o.years))
              && o.offer
              && (
                (o.offer.stortingenInterval === 'Per maand')
                || (o.offer.stortingenInterval === 'Per kwartaal' && (startDate.getMonth() - date.getMonth() + 12) % 3 === 0)
                || (o.offer.stortingenInterval === 'Per halfjaar' && (startDate.getMonth() - date.getMonth() + 12) % 6 === 0)
                || (o.offer.stortingenInterval === 'Per jaar' && (startDate.getMonth() - date.getMonth() + 12) % 12 === 0)
              )
            ) {
              return true;
            }
          }
          return false;
        }).length]);
        date.setMonth(date.getMonth() + 1);
      }
      return temp;
    },
  },
  methods: {
    slice,
    filter,
    find,
    textFirstAction(action) {
      if (action === -1) {
        return '?';
      }
      if (action === 0) {
        return 'Deze maand';
      }
      if (action === 1) {
        return 'Volgende maand';
      }
      return `${action} maanden`;
    },
    toFirstYear(payout) {
      if (!payout.offerAdmin || !payout.offerAdmin.calculation) {
        return '-';
      }
      if (Number(payout.offer.offerType) === 1 || Number(payout.offer.offerType) === 4) {
        return this.formatPrice(payout.offerAdmin.calculation.charts.chart2[0][2], true);
      }
      if (Number(payout.offer.offerType) !== 0 && Number(payout.offer.offerType) !== 5) {
        return this.formatPrice(payout.offerAdmin.calculation.charts.chart1[0][2], true);
      }
      return this.formatPrice(payout.offerAdmin.calculation.charts.chart2[0][1], true);
    },
    download() {
      const lineArray = [];
      const mapped = map(this.payouts, (payout) => ({
        port: payout.id,
        intakeDatum: (new Date(payout.intake_date)).toLocaleDateString(),
        startDatum: payout.revision !== null ? `${
          (new Date(payout.start_date)).getMonth() + 1
        } ${
          (new Date(payout.start_date)).getFullYear()
        }` : '',
        startBedrag: payout.revision !== null ? this.formatPrice(sum(JSON.parse(payout.initials || [0])), true) : '-',
        uRendement: payout.revision !== null ? this.formatPrice(payout.interest) : '-',
        rekenRendement: payout.revision !== null ? this.formatPrice(payout.calc_interest) : '-',
        looptijd: payout.revision !== null ? payout.years : '-',
        type: payout.offer ? this.toOfferType(Number(payout.offer.offerType)) : '-',
        intakeStartBedrag: payout.offer ? this.formatPrice(payout.offer.vermogen, true) : '-',
        intakeURendement: payout.offerAdmin ? this.formatPrice(payout.offerAdmin.urendement) : '-',
        intakeRekenRendement: payout.offerAdmin ? this.formatPrice(payout.offerAdmin.profile) : '-',
        intakeLooptijd: payout.offer ? payout.offer.looptijd : '-',
        eersteUitkering: this.toFirstYear(payout),
        uitbetalingInterval: payout.offer ? payout.offer.stortingenInterval : '-',
        uitbetalingStart: payout.intakeData.rekeningData.paymentStart,
        uitzonderingloonheffing: payout.intakeData.rekeningData.uitzonderingloonheffing,
        loonheffingskorting: payout.intakeData.rekeningData.loonheffingskorting,
        nextOfKin: payout.offer ? payout.offer.nextOfKin : '-',
        revision: payout.revision,
        firstAction: payout.firstAction,
        revisionDate: payout.revision !== null
          ? `${(new Date(payout.lastpayout_date)).getMonth()} ${(new Date(payout.lastpayout_date)).getFullYear()}`
          : '-',
      }));
      lineArray.push(Object.keys(mapped[0]).join(';'));
      mapped.forEach((infoArray) => {
        lineArray.push(Object.values(infoArray).join(';'));
      });
      const file = new File(
        [lineArray.join('\n')],
        `${(new Date()).getFullYear()}${(new Date()).getMonth() + 1 < 10 ? `0${(new Date()).getMonth() + 1}` : (new Date()).getMonth() + 1}${(new Date()).getDate() < 10 ? `0${(new Date()).getDate()}` : (new Date()).getDate()}-payouts.csv`,
        { type: 'text/csv;charset=utf-8' },
      );
      FileSaver.saveAs(file);
    },
    openPayout(port) {
      this.$parent.other = port;
      this.$store.state.currentView = 'Payouts';
    },
    redoIntake(port) {
      this.sdk.redoIntake(port, (response) => {
        window.open(`?intake=${response.data.intake}`);
        this.getProfiles();
      });
    },
    searchFilter(obj) {
      if (
        (this.hasOffer === null || this.hasOffer !== !obj.offer)
        && (this.hasPayout === null || this.hasPayout !== (obj.revision === null))
        && (this.hasIntake === null || this.hasIntake === (obj.complete_date === null))
        && (this.hasAction === null || this.hasAction === obj.firstAction)
      ) {
        if (obj.id.toLowerCase().indexOf(this.search) > -1) {
          return true;
        }
      }
      return false;
    },
    updateSearch() {
      this.currentPage = 0;
      this.search = this.$refs.search.value.toLowerCase().trim();
    },
    toOfferType(id) {
      if (id === 5) {
        return 'Netto Laag';
      }
      if (id === 4) {
        return 'Netto Hoog';
      }
      if (id === 3) {
        return 'GH Uitkering';
      }
      if (id === 2) {
        return 'GH Looptijd';
      }
      if (id === 1) {
        return 'Lijfrente Hoog';
      }
      return 'Lijfrente Laag';
    },
    getProfiles() {
      this.sdk.getAdminPayoutable((response) => {
        const date = new Date();
        if (response.status === 200) {
          for (let i = 0; i < response.data.length; i += 1) {
            response.data[i].intakeData = JSON.parse(response.data[i].intake);
            response.data[i].intakeAdmin = JSON.parse(response.data[i].admin);
            response.data[i].offer = find(
              response.data[i].intakeData.offers,
              (o) => o.selected && !o.deleted,
            );
            if (response.data[i].offer) {
              response.data[i].offerAdmin = response.data[i].intakeAdmin.offers[
                response.data[i].offer.offerId
              ];
            }
            response.data[i].firstAction = -1;
            if (response.data[i].start_date) {
              const startDate = new Date(response.data[i].start_date);
              if (
                startDate.getMonth() === date.getMonth()
                && startDate.getFullYear() === date.getFullYear()
              ) {
                response.data[i].firstAction = 1;
              }
              if (
                date.getFullYear() < (startDate.getFullYear() + Number(response.data[i].years))
                && response.data[i].offer
              ) {
                response.data[i].firstAction = startDate.getMonth() - date.getMonth() + 12;
                if (response.data[i].offer && response.data[i].offer.stortingenInterval === 'Per jaar') {
                  response.data[i].firstAction %= 12;
                } else if (response.data[i].offer && response.data[i].offer.stortingenInterval === 'Per halfjaar') {
                  response.data[i].firstAction %= 6;
                } else if (response.data[i].offer && response.data[i].offer.stortingenInterval === 'Per kwartaal') {
                  response.data[i].firstAction %= 3;
                } else {
                  response.data[i].firstAction = 0;
                }
              }
            }
          }
          this.payouts = response.data;
          this.$nextTick(() => {
            this.resultsPerPage = 10;
          });
        } else {
          this.sdk.logout();
          window.location.reload();
        }
      });
    },
    setTooltipContent(object) {
      const tooltip = document.getElementById('payouts-tooltip');
      if (object !== null) {
        tooltip.style.display = 'inline-block';
        tooltip.innerHTML = `<b>Over ${this.rows[object.row][0] ? `${this.rows[object.row][0]} - ` : ''}${this.columns[object.column].label}</b>: ${this.formatPrice(this.rows[object.row][object.column], true)} payouts acties moeten worden verwerkt`;
      } else {
        tooltip.style.display = 'none';
      }
    },
  },
};
</script>
